var Signal;
(function (Signal) {
    Signal["SignInRequest"] = "sign-in-request";
    Signal["SignOutRequest"] = "sign-out-request";
})(Signal || (Signal = {}));

export { Signal };
